import '~/js/libs/jquery-ui.selectmenu.min.js';

// Variable Declaration
const $resortSelect = $('.compare-content-select-block select');
const selectedResorts = new Array(3);
const selectsElem = document.querySelectorAll('.compare-content-select-block select');

// Select resorts
for(let i = 0; i < selectsElem.length; i++) {
  selectsElem[i].selectedIndex = i;
}

// Attr handlers
const removeAttrHandler = (option, attr) => {
  $resortSelect.find('option[value="' + option + '"]').removeAttr(attr);
};

// Select handler
const resortSelectHandler = (event, data) => {
  const $selectId = $(event.target).data('resortSelect');
  const $resort = $('[data-resort="' + $selectId + '"]');
  const selectedOption = data.item.value;
  const resortIndex = $selectId - 1;
  const otherSelects = $resortSelect.not($('[data-resort-select="' + $selectId + '"]'));
  const $selectedResort =  $('.compare-content-ready-data-full[data-ready-resort="' + selectedOption + '"]');
  const $clearResort =  $('.compare-content-ready-data-clear');

  if (selectedOption !== '') {
    $resort.html($selectedResort.html());

    if (selectedOption !== selectedResorts[resortIndex]) {
      removeAttrHandler(selectedResorts[resortIndex], 'disabled');
    }

    selectedResorts[resortIndex] = selectedOption;
    otherSelects.find('option[value="' + selectedOption + '"]').attr('disabled', 'disabled');
    $resortSelect.selectmenu('refresh', true );

  } else {
    removeAttrHandler(selectedResorts[resortIndex], 'disabled');
    selectedResorts[resortIndex] = undefined;
    $resortSelect.selectmenu('refresh', true );

    $resort.html($clearResort.html());
  }
};

const resortSelectHandlerDefault = (event) => {
  const $selectId = $(event.target).data('resortSelect');
  const $resort = $('[data-resort="' + $selectId + '"]');
  const selectedOption = event.target.value;
  const resortIndex = $selectId - 1;
  const otherSelects = $resortSelect.not($('[data-resort-select="' + $selectId + '"]'));
  const $selectedResort =  $('.compare-content-ready-data-full[data-ready-resort="' + selectedOption + '"]');

  // $resortSelect.find('option').removeAttr('disabled');

  $resort.html($selectedResort.html());

  if (selectedOption !== selectedResorts[resortIndex]) {
    removeAttrHandler(selectedResorts[resortIndex], 'disabled');
  }

  selectedResorts[resortIndex] = selectedOption;
  otherSelects.find('option[value="' + selectedOption + '"]').attr('disabled', 'disabled');
  removeAttrHandler(selectedResorts[0], 'disabled');
};

// Initialization selectmenu
$resortSelect.selectmenu({
  change: resortSelectHandler,
  create: resortSelectHandlerDefault
});

$(window).on('resize', ()=>{
  $resortSelect.selectmenu('close');
});

$(window).on('click touchstart', (event)=>{
  if (!$(event.target).closest('.ui-selectmenu-menu').length && !$(event.target).closest('.ui-selectmenu-button').length) {
    $resortSelect.selectmenu('close');
  }
});
